var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{staticClass:"h-40",attrs:{"cols":"12","lg":"12"}},[_c('canvas',{attrs:{"id":"myChart","width":"500","height":"200"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }